import styled from "styled-components";

export const Container = styled.div`
  margin-right: 0.3rem;
  cursor: pointer;
  width: 2rem;
`;

export const StyledImg = styled.img`
  height: 1.8rem;
  width: 1.8rem;
`;
